import { selectorFamily } from 'recoil';
import interventionsState, { InterventionState } from '../atoms/ticketInterventions';

const interventionState = selectorFamily<InterventionState, InterventionState['id']>({
  key: 'intervention',
  get: (id) => ({ get }) => {
    const interventions = get(interventionsState);
    return interventions[id];
  },
  set: (id) => ({ set }, newIntervention) =>
    set(interventionsState, (prevState) => ({ ...prevState, [id]: newIntervention as InterventionState })),
});

const ticketInterventionsState = selectorFamily<InterventionState[], InterventionState['ticketId']>({
  key: 'ticketInterventions',
  get: (ticketId) => ({ get }) => {
    const interventions = get(interventionsState);
    return Object.values(interventions).filter((intervention) => intervention.ticketId === ticketId);
  },
});

export { interventionState, ticketInterventionsState };
